// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RubricPromptData } from './rubricPromptData';

/**
 * Container for batch export of training data
 */
export interface TrainingDataExport {
  dataset_name?: string;
  version?: string;
  exported_at: string;
  cases: RubricPromptData[];
}
